module.exports = __webpack_public_path__ + "static/media/mbys_con_saf.f508d10f.png";